import {useMutation, useQuery, useQueryClient} from "react-query";
import {createPracticeSet, deletePracticeSet, fetchPracticeGenerationOptions, fetchPracticeSet, fetchPracticeSets, generateNoteQuiz, generatePracticeSet, updatePracticeSet} from "../api/practiceApi";

export function usePracticeSets(token) {
    return useQuery({
        queryKey: ['practice-sets'],
        queryFn: () => fetchPracticeSets(token),
        enabled: !!token,
    });
}

export function usePracticeSet(token, id) {
    return useQuery({
        queryKey: ['practice-set', id],
        queryFn: () => fetchPracticeSet(token, id),
        enabled: !!token && !!id,
    });
}

export function useCreatePracticeSet(token) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (practiceSetData) => createPracticeSet(token, practiceSetData),
        onSuccess: () => {
            queryClient.invalidateQueries(['practice-sets']);
        },
    });
}

export function useGenerateNoteQuiz(token) {
    return useMutation({
        mutationFn: (noteId) => generateNoteQuiz(token, noteId),
    });
}

export function usePracticeGenerationOptions(token, enabled = true) {
    return useQuery({
        queryKey: ['practice-generation-options'],
        queryFn: () => fetchPracticeGenerationOptions(token),
        enabled: !!token && enabled,
        staleTime: 5 * 60 * 1000,
    });
}

export function useGeneratePracticeSet(token) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (generationOptions) => generatePracticeSet(token, generationOptions),
        onSuccess: () => {
            queryClient.invalidateQueries(['practice-sets']);
        },
    });
}

export function useUpdatePracticeSet(token) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({practiceSetId, practiceSetData}) => updatePracticeSet(token, practiceSetId, practiceSetData),
        onSuccess: (updatedPracticeSet) => {
            if (updatedPracticeSet?.id) {
                queryClient.invalidateQueries(['practice-set', updatedPracticeSet.id]);
            }
            queryClient.invalidateQueries(['practice-sets']);
        },
    });
}

export function useDeletePracticeSet(token) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (practiceSetId) => deletePracticeSet(token, practiceSetId),
        onSuccess: (_, practiceSetId) => {
            queryClient.invalidateQueries(['practice-sets']);
            queryClient.removeQueries(['practice-set', practiceSetId]);
        },
    });
}
